__turbopack_context__.v({
  "categoriesWrapper": "VZyEiq_categoriesWrapper",
  "categoryImage": "VZyEiq_categoryImage",
  "categoryItem": "VZyEiq_categoryItem",
  "categoryName": "VZyEiq_categoryName",
  "divider": "VZyEiq_divider",
  "itemHead": "VZyEiq_itemHead",
  "pageTitle": "VZyEiq_pageTitle",
  "seeMore": "VZyEiq_seeMore",
  "subcategoryItem": "VZyEiq_subcategoryItem",
  "subcategoryName": "VZyEiq_subcategoryName",
  "subcategoryQuantity": "VZyEiq_subcategoryQuantity",
});
